import { render, staticRenderFns } from "./DaofangShenpi2.vue?vue&type=template&id=41c52c54&scoped=true"
import script from "./DaofangShenpi2.vue?vue&type=script&lang=js"
export * from "./DaofangShenpi2.vue?vue&type=script&lang=js"
import style0 from "./DaofangShenpi2.vue?vue&type=style&index=0&id=41c52c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c52c54",
  null
  
)

export default component.exports